import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoDataSourceBaseMixin from './KendoDataSourceBaseMixin'

export default {
    name: 'kendo-datasource',
    mixins: [ KendoDataSourceBaseMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/index.js